export const MTOM_CODE_TEXT = 'MTOM';
export const ERROR_MESSAGES = {
  [MTOM_CODE_TEXT]:
    'Recurring month to month fees are automatically set up for' +
    ' expired leases at your property on the last day of every month. ' +
    'Manual entries are not permitted.',
};
